// Generated by ReScript, PLEASE EDIT WITH CARE


function getSymbol(country) {
  return country._0.currency;
}

function getIsoCode(country) {
  return country._0.iso_code;
}

function getTimezone(country) {
  return country._0.time_zone;
}

function getMobileValidationRegex(country) {
  return country._0.mobile_validation_regex;
}

function countryToString(country) {
  switch (country.TAG | 0) {
    case /* UAE */0 :
        return "uae";
    case /* India */1 :
        return "india";
    case /* BD */2 :
        return "bd";
    case /* TR */3 :
        return "tr";
    
  }
}

var defaultCountry = "india";

export {
  defaultCountry ,
  getSymbol ,
  getIsoCode ,
  getTimezone ,
  getMobileValidationRegex ,
  countryToString ,
  
}
/* No side effect */
